<app-spinner id="spinner" [loading]="spinnerService.loading$ | async" />
<div id="courses-screen">
  <app-header-bar
    title="{{ 'Courses' | translate }}"
    id="header-bar"
    [showButton]="false"
  />
  <app-primary-card *ngIf="!_noData" size="large" id="main-card">
    <div id="course-container">
      <app-course-card
        *ngFor="let course of _courses"
        class="course-card"
        [_title]="course.title"
        [_percentage]="course.percentage"
        [_completed]="course.completed"
        [_todo]="course.todo"
        [_imageLink]="course.imageLink"
        [_url]="course.url"
      />
    </div>
  </app-primary-card>
  <app-primary-card *ngIf="_noData" size="large" id="no-data-card">
    {{ 'Not subscribed to any courses' | translate }}
  </app-primary-card>
</div>
